export const getMappedCookies = () =>
  document.cookie
    .split("; ")
    .reduce<Record<string, string>>((mappedValues, keyvalue) => {
      const [key, ...values] = keyvalue.split("=");
      if (!key) {
        return mappedValues;
      }
      return { ...mappedValues, [key]: values.join("=") };
    }, {});

export const getCookie = (key: string) => {
  const mappedCookies = getMappedCookies();

  if (key in mappedCookies) {
    return mappedCookies[key];
  }

  return null;
};
